export default "__VITE_ASSET__38edb73e__$_?react__"